module.exports = __webpack_public_path__ + "img/copy.1031c689.png";